import $ from 'jquery';
const jQuery = $;

window.$ = $;
window.jQuery = $;

export default $;
export { $, jQuery };
